import mapToRange from '@cotyorg/ccx-utils/js/helpers/mapToRange';
import {
  SET_POSITION_SLIDER,
  SET_STOP_DRAGGING_SLIDER,
  SET_TRACK_DIMENSIONS_SLIDER,
  SET_VALUE_SLIDER,
} from './actions';
import { mapPositionToValue, mapPositionToPercentage } from '../components/shared/helper';

const setPosition = (state, {
  id,
  position,
  isDragging,
  min,
  max,
}) => {
  const { trackLeft, trackWidth } = state[id];
  return {
    ...state,
    [id]: {
      ...state[id],
      currentValue: mapPositionToValue({
        position,
        min,
        max,
        trackLeft,
        trackWidth,
      }),
      currentPercentage: mapPositionToPercentage({
        position,
        trackLeft,
        trackWidth,
      }),
      isDragging: !!isDragging,
    },
  };
};

const setStopDragging = (state, {
  id,
  position,
  min,
  max,
}) => {
  const { trackLeft, trackWidth } = state[id];
  const value = mapPositionToValue({
    position,
    min,
    max,
    trackLeft,
    trackWidth,
  });

  return {
    ...state,
    [id]: {
      ...state[id],
      currentValue: value,
      currentPercentage: mapToRange({
        value,
        inMin: min,
        inMax: max,
        outMin: 0,
        outMax: 100,
      }),
      isDragging: false,
    },
  };
};


const setTrackDimensions = (state, {
  id,
  left,
  width,
  min,
  max,
}) => {
  const { currentValue } = state[id] || {};

  return ({
    ...state,
    [id]: {
      ...state[id],
      trackLeft: left,
      trackWidth: width,
      currentPercentage: mapToRange({
        value: currentValue,
        inMin: min,
        inMax: max,
        outMin: 0,
        outMax: 100,
      }),
    },
  });
};

const setValue = (state, {
  id,
  value,
  min,
  max,
}) => ({
  ...state,
  [id]: {
    ...state[id],
    currentValue: value,
    currentPercentage: mapToRange({
      value,
      inMin: min,
      inMax: max,
      outMin: 0,
      outMax: 100,
    }),
  },
});

const reducer = {
  [SET_POSITION_SLIDER]: setPosition,
  [SET_STOP_DRAGGING_SLIDER]: setStopDragging,
  [SET_TRACK_DIMENSIONS_SLIDER]: setTrackDimensions,
  [SET_VALUE_SLIDER]: setValue,
};

export default (state = {}, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
